import {Injectable} from "@angular/core";
import {FormControl} from "@angular/forms";

@Injectable({
  providedIn: 'root'
})

export class ProdNameBuilder {
  build(parameters: any[]): string {
    let string: string = "";
    for (let i = 0; i<parameters.length; i++) {
        string += " " + "\n" + parameters[i].name + " (" + this.formatCnpjCpf(parameters[i].cpfCNPJ) + "),";
    }
    string = string.slice(1, string.length-1);
    return string;
  }

  formatCnpjCpf(value) {
    const CPF_LENGTH = 11;
    const cnpjCpf = value.replace(/\D/g, '');

    if (cnpjCpf.length === CPF_LENGTH) {
      return cnpjCpf.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/g, "\$1.\$2.\$3-\$4");
    }

    return cnpjCpf.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/g, "\$1.\$2.\$3/\$4-\$5");
  }
}
